import { systemRequest } from "../../utils/systemRequest";
import { request } from "../../utils/request";
import type { Menu } from "./types";

/**
 * 获取当前用户的所有菜单权限
 * @returns Promise<Menu.MenuPermissionsResponse> 返回包含用户信息、角色、权限和菜单的完整响应
 */
export const getMenuPermissionsApi = () => {
  // 使用 request 而不是 systemRequest，因为接口路径是 /system/auth/get-permission-info
  return request<Menu.MenuPermissionsResponse>("/system/auth/get-permission-info", {
    method: "GET",
  });
};

/**
 * 获取所有的菜单权限
 * @returns Promise<Menu.AllMenuResponse> 返回所有的菜单权限列表
 */
export const getAllMenuPermissionsApi = () => {
  return request<Menu.AllMenuResponse>("/system/menu/list", {
    method: "GET",
  });
};

/**
 * 创建菜单权限
 * @param menuData 菜单数据
 * @returns Promise<any> 创建结果
 */
export const createMenuApi = (menuData: {
  name: string; // 必填 - 名字
  permission: string; // 权限标识
  action?: string; // 前端菜单动作标识（可选，≤100 字符），仅 type=1/2 配套使用
  type: number; // 必填 - DIR(1)目录 MENU(2)菜单 BUTTON(3)按钮
  sort: number; // 必填 - 显示顺序
  parentId: number; // 必填 - 上级菜单
  path?: string; // 路由地址
  icon?: string; // 菜单图标
  component?: string; // 组件路径
  status: number; // 必填 - 显示状态 0是开启 1是禁用
  visible: boolean; // 显示状态
  displayPosition?: 'sidebar' | 'avatarPopup'; // 显示位置：sidebar=侧边栏，avatarPopup=头像菜单
}) => {
  return request<any>("/system/menu/create", {
    method: "POST",
    body: menuData,
  });
};

/**
 * 角色菜单赋权
 * @param assignData 赋权数据
 * @returns Promise<any> 赋权结果
 */
export const assignMenuApi = (assignData: {
  roleId: number;
  menuIds: number[];
}) => {
  return request<any>("/system/permission/assign-role-menu", {
    method: "POST",
    body: assignData,
  });
};

/**
 * 角色赋权
 * @param roleAssignData 角色赋权数据
 * @returns Promise<any> 赋权结果
 */
export const assignRoleApi = (roleAssignData: {
  user_id: number;
  role_key: string;
}) => {
  return systemRequest<any>("/role/assign", {
    method: "POST",
    body: roleAssignData,
  });
};

/**
 * 更新菜单权限
 * @param menuId 菜单ID
 * @param menuData 菜单数据
 * @returns Promise<any> 更新结果
 */
export const updateMenuApi = (menuId: number, menuData: {
  id: number; // 必填 - 菜单编号
  name: string; // 必填 - 名字
  permission: string; // 权限标识
  action?: string; // 前端菜单动作标识（可选，≤100 字符），仅 type=1/2 配套使用
  type: number; // 必填 - DIR(1)目录 MENU(2)菜单 BUTTON(3)按钮
  sort: number; // 必填 - 显示顺序
  parentId: number; // 必填 - 上级菜单
  path?: string; // 路由地址
  icon?: string; // 菜单图标
  component?: string; // 组件路径
  status: number; // 必填 - 显示状态 0是开启 1是禁用
  visible: boolean; // 显示状态
  displayPosition?: 'sidebar' | 'avatarPopup'; // 显示位置：sidebar=侧边栏，avatarPopup=头像菜单
}) => {
  return request<any>("/system/menu/update", {
    method: "PUT",
    params: { id: menuId },
    body: menuData,
  });
};

/**
 * 删除菜单
 * @param menuId 菜单ID
 * @returns Promise<any> 删除结果
 */
export const deleteMenuApi = (menuId: number) => {
  return request<any>("/system/menu/delete", {
    method: "DELETE",
    params: { id: menuId },
  });
};

/**
 * 获取角色拥有的菜单编号列表
 * @param roleId 角色ID
 * @returns Promise<Menu.RoleMenusResponse> 返回角色拥有的菜单ID数组
 */
export const getRoleMenusApi = (roleId: number) => {
  return request<Menu.RoleMenusResponse>("/system/permission/list-role-menus", {
    method: "GET",
    params: { roleId },
  });
};



